/**
 * Ba tab media trên PDP: Images — 360 — Video.
 *
 * Ảnh 360 và video đều do CRM tự host trên S3, lấy qua
 * /api/v1/media/{websiteId}/{handle}?type=spin|video&material=...
 * Spin trả một bộ frame ({base_url}/{i}.jpg, i từ 0); video trả danh sách.
 *
 * Tự host video vì gói Shopify chặn ở 250 video và store đã chạm trần.
 *
 * Panel được chèn bằng JS chứ không render sẵn trong Liquid: slider của theme gom danh sách
 * thumbnail một lần lúc khởi tạo nên markup có sẵn sẽ bị handler của nó xử lý nhầm.
 */
(function () {
  'use strict';

  if (window.__pdpHostedMediaReady) return;
  window.__pdpHostedMediaReady = true;

  var config = document.getElementById('pdp-ring-spin-config');
  if (!config) return;

  var apiBase   = config.getAttribute('data-api-base');
  var websiteId = config.getAttribute('data-website-id');
  var handle    = config.getAttribute('data-handle');
  if (!apiBase || !websiteId || !handle) return;

  var PIXELS_PER_FRAME = 5;

  // Cung chỉ hướng kéo: hai mũi tên hai đầu, chấm ở giữa. Bỏ class Tailwind của bản gốc vì
  // theme không dùng Tailwind — vị trí do .cstm-spin-hint lo.
  var SPIN_TRACK_SVG =
    '<svg class="cstm-spin-hint-track" width="151" height="18" viewBox="0 0 151 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M150.417 0.644691C148.383 2.02048 146.196 3.1495 143.962 4.15117C143.812 4.21799 143.637 4.15134 143.571 4.00225C143.504 3.85317 143.571 3.67812 143.72 3.61131C143.722 3.61026 143.726 3.6085 143.728 3.60763C145.969 2.68138 148.164 1.62813 150.21 0.329868C150.298 0.273574 150.414 0.299178 150.47 0.386867C150.525 0.472991 150.501 0.587348 150.417 0.644691V0.644691Z" fill="#999999"></path>' +
    '<path d="M137.1 6.77542L130.053 8.8256C129.813 8.89523 129.563 8.75755 129.493 8.51813C129.423 8.27871 129.561 8.02826 129.8 7.95863L129.806 7.95705L129.835 7.94916L136.866 6.04L136.892 6.03298C137.097 5.97721 137.309 6.09857 137.365 6.30414C137.42 6.50725 137.302 6.71684 137.1 6.77542Z" fill="#999999"></path>' +
    '<path d="M122.906 10.4761L115.693 11.8112C115.376 11.8697 115.072 11.6607 115.014 11.3444C114.955 11.028 115.164 10.7241 115.481 10.6655C115.483 10.665 115.485 10.6646 115.488 10.6643L115.513 10.6601L122.706 9.46141L122.727 9.45791C123.008 9.41108 123.275 9.6012 123.322 9.88289C123.368 10.1612 123.182 10.4247 122.906 10.4761L122.906 10.4761Z" fill="#999999"></path>' +
    '<path d="M108.436 12.8532L101.146 13.6473C100.794 13.6856 100.477 13.4311 100.439 13.0789C100.4 12.7265 100.655 12.4099 101.007 12.3715L101.011 12.371L101.03 12.3691L108.286 11.6221L108.305 11.6201C108.646 11.5851 108.95 11.8327 108.985 12.1733C109.02 12.5127 108.774 12.8161 108.436 12.8531L108.436 12.8532Z" fill="#999999"></path>' +
    '<path d="M49.8932 13.6545L42.6008 12.8621C42.2598 12.8249 42.0135 12.5185 42.0506 12.1776C42.0875 11.838 42.3917 11.5923 42.7311 11.627L42.7503 11.6289L50.0093 12.3742L50.0283 12.3761C50.3815 12.4122 50.6384 12.7279 50.6021 13.0812C50.5659 13.4344 50.2502 13.6912 49.897 13.6551L49.8932 13.6545V13.6545Z" fill="#999999"></path>' +
    '<path d="M35.3374 11.8231L28.1195 10.4889C27.8375 10.4368 27.6512 10.166 27.7033 9.88392C27.7548 9.60522 28.02 9.42 28.2984 9.46613L28.3199 9.46964L35.5176 10.6664L35.5397 10.67C35.8586 10.723 36.0741 11.0245 36.0211 11.3434C35.9681 11.6622 35.6665 11.8778 35.3477 11.8248C35.3452 11.8245 35.3398 11.8234 35.3373 11.8231H35.3374Z" fill="#999999"></path>' +
    '<path d="M20.9636 8.83857L13.9126 6.79015C13.7073 6.73052 13.5891 6.51566 13.6488 6.31045C13.7078 6.10751 13.9183 5.98965 14.1215 6.04472L14.1474 6.05173L21.1818 7.95844L21.2087 7.96563C21.4503 8.03105 21.5931 8.28011 21.5276 8.5218C21.4621 8.76348 21.2132 8.90626 20.9715 8.84066C20.9696 8.84012 20.9655 8.83908 20.9636 8.83856L20.9636 8.83857Z" fill="#999999"></path>' +
    '<path d="M7.04703 4.16889C4.81005 3.16793 2.6207 2.03944 0.58358 0.665061C0.496767 0.606467 0.473878 0.488776 0.532458 0.401963C0.589902 0.316716 0.705308 0.293742 0.791604 0.348111C2.84108 1.6448 5.03842 2.69682 7.28126 3.62185C7.43332 3.68411 7.50611 3.85793 7.44394 4.00999C7.38168 4.16205 7.20794 4.23484 7.05588 4.17258C7.05359 4.17171 7.0493 4.16978 7.04703 4.1689V4.16889Z" fill="#999999"></path>' +
    '<path d="M65.0514 11.1752L58.1611 13.5809L64.6288 16.9225L65.0514 11.1752Z" fill="black"></path>' +
    '<path d="M86.8892 11.2564L87.2593 17.0035L93.7795 13.5937L86.8892 11.2564Z" fill="black"></path>' +
    '<ellipse cx="75.4999" cy="14.5645" rx="1.9306" ry="1.9306" fill="black"></ellipse>' +
    '</svg>';

  var spin = { frames: [], current: 0, viewer: null, img: null, bound: false };
  var video = { panel: null, items: [], bound: false };

  function materialSlug(material) {
    return String(material || '').toLowerCase().replace(/\s+/g, '-');
  }

  /** Chất liệu đang chọn: ưu tiên nút variant, lùi về nhãn hiển thị nếu chưa có. */
  function currentMaterial() {
    var active = document.querySelector('.cli-material-products .cli-item.active a[data-option-value]');
    if (active) return active.getAttribute('data-option-value');

    var label = document.querySelector('.cli-material-products .selected-value');
    return label ? label.textContent.trim() : '';
  }

  /** Carat đang chọn — chỉ dùng cho video; ring-spin không đổi theo carat nên không cần. */
  function currentCarat() {
    // Không lọc theo container: khối Material cũng mang class cli-stone-products, nên chính
    // data-option-name mới là thứ phân biệt.
    var active = document.querySelector('.cli-item.active a[data-option-name="Carat"]');
    return active ? active.getAttribute('data-option-value') : '';
  }

  function fetchMedia(type, material, carat) {
    var url = apiBase + '/api/v1/media/' + websiteId + '/' + encodeURIComponent(handle)
      + '?type=' + type + '&material=' + encodeURIComponent(materialSlug(material));

    // Thiếu carat thì server trả mọi video của chất liệu, nên video mặc định có thể lệch với
    // carat khách đang chọn. Server tự lùi về danh sách đầy đủ nếu carat đó chưa có video.
    if (carat) url += '&carat=' + encodeURIComponent(carat);

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) {
        return json && json.error === false && json.data ? json.data : null;
      })
      .catch(function () { return null; });
  }

  // --- Thanh tab ---------------------------------------------------------

  // Thứ tự hiển thị và nhãn của từng tab
  var TABS = [
    { name: 'images', label: 'Images' },
    { name: 'spin', label: '360°' },
    { name: 'hostedvideo', label: 'Video' },
  ];

  // Tab nào đang bị ẩn. Mỗi panel có một bản thanh tab riêng và chúng được dựng ở các thời
  // điểm khác nhau (spin xong trước, video xong sau), nên thanh dựng sau phải tra lại đây —
  // không thì nút vừa ẩn xong lại mọc lên ở thanh mới.
  var hiddenTabs = {};

  /**
   * Mỗi panel mang một bản thanh tab riêng, đúng như theme làm: thanh tab nằm đè lên ảnh bên
   * trong panel, nên nếu chỉ có một bản thì chuyển tab là nó biến mất cùng panel cũ.
   *
   * Nút của panel nào thì panel đó tự đánh dấu active — panel chỉ hiện khi tab của nó đang chọn.
   */
  function ensureNavIn(panel, activeTab) {
    var wrapper = panel.querySelector('.cstm-featured-image-wrapper');
    if (!wrapper) return null;

    var nav = wrapper.querySelector('.cstm-desktop-tab-nav-overlay');
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'cstm-desktop-tab-nav-overlay';
      wrapper.appendChild(nav);
    }

    TABS.forEach(function (tab) {
      var button = nav.querySelector('[data-tab="' + tab.name + '"]');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'cstm-desktop-tab-btn';
        button.setAttribute('data-tab', tab.name);
        button.textContent = tab.label;
        nav.appendChild(button);
      }
      button.hidden = !!hiddenTabs[tab.name];
      button.classList.toggle('active', tab.name === activeTab);
    });

    return nav;
  }

  /**
   * Bổ sung nút còn thiếu vào các thanh tab do Liquid render sẵn, và tạo thanh cho panel ảnh
   * nếu chưa có — theme chỉ render thanh khi sản phẩm có video trên Shopify, mà video của ta
   * nằm trên S3 nên điều kiện đó không còn đúng.
   */
  function ensureNavInExisting() {
    var images = document.getElementById('cstm-desktop-images');
    if (images) ensureNavIn(images, 'images');

    document.querySelectorAll('.cstm-desktop-tab-panel').forEach(function (panel) {
      var nav = panel.querySelector('.cstm-desktop-tab-nav-overlay');
      if (!nav) return;

      TABS.forEach(function (tab) {
        if (nav.querySelector('[data-tab="' + tab.name + '"]')) return;

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'cstm-desktop-tab-btn';
        button.setAttribute('data-tab', tab.name);
        button.textContent = tab.label;
        button.hidden = !!hiddenTabs[tab.name];
        insertTabInOrder(nav, button, tab.name);
      });
    });
  }

  /**
   * Thanh do Liquid render sẵn đã có Images + Video, nên nút thiếu (360°) phải chèn đúng vị trí
   * theo TABS chứ không nối vào cuối — không thì thứ tự lệch so với thanh do JS tự dựng.
   */
  function insertTabInOrder(nav, button, tabName) {
    var index = -1;
    for (var i = 0; i < TABS.length; i++) {
      if (TABS[i].name === tabName) { index = i; break; }
    }

    for (var next = index + 1; index > -1 && next < TABS.length; next++) {
      var after = nav.querySelector('[data-tab="' + TABS[next].name + '"]');
      if (after) { nav.insertBefore(button, after); return; }
    }

    nav.appendChild(button);
  }

  /** Panel mới dựng theo đúng bố cục của theme: khung media + thanh tab đè lên, dải thumbnail dưới. */
  function ensurePanel(id) {
    var existing = document.getElementById(id);
    if (existing) return existing;

    var images = document.getElementById('cstm-desktop-images');
    var host = images ? images.parentElement : document.querySelector('.cstm-pmg-desktop-layout');
    if (!host) return null;

    var panel = document.createElement('div');
    panel.className = 'cstm-desktop-tab-panel';
    panel.id = id;
    panel.innerHTML =
      '<div class="cstm-pmg-desktop-layout">' +
      '<div class="cstm-featured-image-wrapper">' +
      '<div class="cstm-pmg-img-wrapper"></div>' +
      '</div>' +
      '</div>';

    host.appendChild(panel);
    return panel;
  }

  /** Ẩn tab ở mọi thanh; đang đứng ở đó thì đưa về Images cho khỏi kẹt ở panel rỗng. */
  function hideTab(tabName) {
    var wasActive = false;
    hiddenTabs[tabName] = true;

    document.querySelectorAll('.cstm-desktop-tab-btn[data-tab="' + tabName + '"]').forEach(function (button) {
      if (button.classList.contains('active')) wasActive = true;
      button.hidden = true;
    });

    if (wasActive) {
      var images = document.querySelector('.cstm-desktop-tab-panel.active .cstm-desktop-tab-btn[data-tab="images"]')
        || document.querySelector('.cstm-desktop-tab-btn[data-tab="images"]');
      if (images) images.click();
    }
  }

  function showTab(tabName) {
    hiddenTabs[tabName] = false;

    document.querySelectorAll('.cstm-desktop-tab-btn[data-tab="' + tabName + '"]').forEach(function (button) {
      button.hidden = false;
    });
  }

  /**
   * Theme chỉ set active cho đúng nút vừa bấm. Với nhiều thanh tab, nút cùng loại ở các thanh
   * khác bị bỏ sót nên thanh của panel vừa hiện ra trông như chưa chọn gì. Đồng bộ lại sau.
   */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cstm-desktop-tab-btn');
    if (!button) return;

    var tabName = button.getAttribute('data-tab');
    document.querySelectorAll('.cstm-desktop-tab-btn').forEach(function (other) {
      other.classList.toggle('active', other.getAttribute('data-tab') === tabName);
    });

    // Video chạy ngay khi mở tab, và dừng khi rời đi để không phát ngầm dưới tab khác
    if (tabName === 'hostedvideo') {
      playActiveVideo();
    } else {
      pauseAllVideos();
    }

    moveImageThumbs(tabName === 'spin');
  });

  /**
   * Dải thumbnail ảnh nằm trong panel Images nên biến mất theo panel khi chuyển sang 360.
   * Chuyển chính node đó sang panel 360 thay vì nhân bản — giữ nguyên mọi handler và trạng
   * thái active mà theme đã gắn; nhớ vị trí cũ để trả về đúng chỗ.
   */
  function moveImageThumbs(toSpin) {
    var strip = document.querySelector('.cstm-gallery-slider-main');
    if (!strip) return;

    if (!strip._homeParent) {
      strip._homeParent = strip.parentElement;
      strip._homeNext = strip.nextElementSibling;
    }

    if (!toSpin) {
      if (strip.parentElement !== strip._homeParent) {
        strip._homeParent.insertBefore(strip, strip._homeNext);
      }
      return;
    }

    var panel = document.getElementById('cstm-desktop-spin');
    var layout = panel && panel.querySelector('.cstm-pmg-desktop-layout');
    if (layout) layout.appendChild(strip);
  }

  /**
   * Bấm thumbnail là muốn xem ảnh đó, nhưng ảnh lớn nằm ở panel Images đang bị ẩn — nên quay
   * về tab Images để thấy kết quả, thay vì bấm xong không thấy gì đổi.
   */
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.cstm-gallery-slider-main .cstm-image-slide')) return;

    var spin = document.querySelector('.cstm-desktop-tab-btn[data-tab="spin"].active');
    if (!spin) return;

    var images = document.querySelector('#cstm-desktop-spin .cstm-desktop-tab-btn[data-tab="images"]')
      || document.querySelector('.cstm-desktop-tab-btn[data-tab="images"]');
    if (images) images.click();
  });

  // --- 360 ---------------------------------------------------------------

  function buildSpin() {
    var panel = ensurePanel('cstm-desktop-spin');
    if (!panel) return false;

    ensureNavInExisting();
    ensureNavIn(panel, 'spin');
    showTab('spin');

    var media = panel.querySelector('.cstm-pmg-img-wrapper');
    if (media && !media.querySelector('.cstm-spin-viewer')) {
      media.innerHTML =
        '<div class="cstm-spin-viewer">' +
        '<img class="cstm-spin-img" alt="360°">' +
        '<div class="cstm-spin-hint">' +
        '<span class="cstm-spin-hint-label">Drag to spin</span>' +
        SPIN_TRACK_SVG +
        '</div>' +
        '</div>';
    }

    spin.viewer = panel.querySelector('.cstm-spin-viewer');
    spin.img = panel.querySelector('.cstm-spin-img');
    return !!spin.viewer;
  }

  function setFrame(index) {
    if (!spin.frames.length) return;
    var count = spin.frames.length;
    spin.current = ((index % count) + count) % count;
    spin.img.src = spin.frames[spin.current];
  }

  /** Kéo ngang để xoay. Gộp bằng rAF để mỗi khung hình chỉ đổi src một lần. */
  function bindDrag() {
    if (spin.bound) return;
    spin.bound = true;

    var dragging = false;
    var startX = 0;
    var startFrame = 0;
    var pending = false;
    var latest = null;

    function pointerX(e) {
      return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
    }

    function applyLatest() {
      if (!latest) return;
      setFrame(startFrame - Math.round((pointerX(latest) - startX) / PIXELS_PER_FRAME));
    }

    function onStart(e) {
      dragging = true;
      startX = pointerX(e);
      startFrame = spin.current;
      spin.viewer.classList.add('dragging');
      e.stopPropagation();
    }

    function onMove(e) {
      if (!dragging) return;
      latest = e;
      if (pending) return;
      pending = true;

      requestAnimationFrame(function () {
        pending = false;
        if (dragging) applyLatest();
      });
    }

    function onEnd() {
      if (!dragging) return;

      // Áp nốt lần di chuyển cuối: thả tay trong cùng khung hình với cú move cuối thì callback
      // rAF sẽ thấy dragging đã tắt và bỏ qua, làm mất đoạn xoay cuối.
      applyLatest();

      dragging = false;
      latest = null;
      spin.viewer.classList.remove('dragging');
    }

    spin.viewer.addEventListener('mousedown', onStart);
    spin.viewer.addEventListener('touchstart', onStart, { passive: true });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: true });
    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchend', onEnd);
  }

  function applySpin(data) {
    if (!buildSpin()) return;

    spin.frames = [];
    for (var i = 0; i < data.frame_count; i++) {
      spin.frames.push(data.base_url + '/' + i + '.jpg');
    }

    spin.current = 0;
    spin.img.src = spin.frames[0];

    // Nạp sẵn các frame còn lại để kéo không giật
    for (var j = 1; j < spin.frames.length; j++) {
      new Image().src = spin.frames[j];
    }

    bindDrag();
    applyMobileSpin();
    autoActivateSpin();
  }

  /**
   * Vào trang thì mở sẵn tab 360° (desktop lẫn mobile) thay vì Images. Chỉ làm một lần ở lượt
   * nạp đầu — đổi chất liệu về sau nạp lại frame nhưng không được giật khách khỏi tab đang xem.
   *
   * Không giả lập click: frame có thể về trước khi handler tab của theme ($(document).ready)
   * kịp gắn, khi đó chỉ nút đổi màu còn panel vẫn là Images và dải thumbnail bị dời vào panel
   * 360 đang ẩn — mất cả thumbnail lẫn hint. Tự đặt trạng thái panel/nút/thumbnail trực tiếp.
   */
  var spinAutoActivated = false;

  function autoActivateSpin() {
    if (spinAutoActivated) return;
    spinAutoActivated = true;

    var panel = document.getElementById('cstm-desktop-spin');
    if (panel) {
      document.querySelectorAll('.cstm-desktop-tab-btn').forEach(function (button) {
        button.classList.toggle('active', button.getAttribute('data-tab') === 'spin');
      });
      document.querySelectorAll('.cstm-desktop-tab-panel').forEach(function (other) {
        other.classList.toggle('active', other === panel);
      });
      pauseAllVideos();
      moveImageThumbs(true);
      // Theme ẩn/hiện hai dải thumbnail theo tab; đặt như lúc ở tab Images
      var imageStrip = document.querySelector('.cstm-gallery-slider-main');
      if (imageStrip) imageStrip.style.display = '';
      document.querySelectorAll('.cstm-video-thumb-slider').forEach(function (el) { el.style.display = 'none'; });
    }

    var host = mobileHost();
    var mobilePanel = document.getElementById('mobile-spin');
    if (host && mobilePanel) {
      host.querySelectorAll('.mobile-tab-btn').forEach(function (button) {
        button.classList.toggle('active', button.getAttribute('data-tab') === 'spin');
      });
      host.querySelectorAll('.mobile-tab-panel').forEach(function (other) {
        other.classList.toggle('active', other === mobilePanel);
      });
      host.querySelectorAll('video').forEach(function (el) { el.pause(); });
    }
  }

  // --- Video -------------------------------------------------------------

  function applyVideos(data) {
    var items = (data && data.items) || [];

    video.panel = ensurePanel('cstm-desktop-hostedvideo');
    if (!video.panel) return;

    ensureNavInExisting();
    ensureNavIn(video.panel, 'hostedvideo');

    applyMobileVideos(items);

    if (!items.length) {
      hideTab('hostedvideo');
      return;
    }

    showTab('hostedvideo');
    video.items = items;

    // Không dùng `controls`: thanh điều khiển gốc của trình duyệt vẽ dải đen đè lên khung
    // vuông. Trang mẫu dùng nút play tự vẽ, còn video để muted + loop.
    // preload="none": mỗi video ~20MB, tải sẵn tất cả sẽ ngốn băng thông của khách
    var media = video.panel.querySelector('.cstm-pmg-img-wrapper');
    media.innerHTML = items.map(function (item, index) {
      // Nhãn carat: mỗi video quay ở một trọng lượng đá khác nhau nên phải nói rõ đang xem cái
      // nào. Dùng lại class có sẵn của theme để khỏi lặp CSS; thứ tự thẻ theo đúng theme —
      // nhãn trước video, overlay sau cùng.
      var label = item.carat
        ? '<div class="shown-carat-label">Shown with ' + item.carat + ' ct</div>'
        : '';

      return '<div class="cstm-desktop-video-slide' + (index === 0 ? ' active' : '') + '">' +
        '<div class="cstm-desktop-video-inner">' + label +
        '<video muted loop playsinline preload="none"' +
        (item.poster_url ? ' poster="' + item.poster_url + '"' : '') +
        '><source src="' + item.url + '" type="' + (item.mime_type || 'video/mp4') + '"></video>' +
        '<div class="cstm-play-overlay"><div class="cstm-play-button">' +
        '<svg viewBox="0 0 24 24" width="22" height="22"><path d="M8 5v14l11-7z"/></svg>' +
        '</div></div>' +
        '</div></div>';
    }).join('');

    buildVideoThumbs(items);

    // Đổi chất liệu khi đang ở tab video sẽ dựng lại danh sách slide; phát tiếp để người xem
    // không phải bấm lại từ đầu
    var button = document.querySelector('.cstm-desktop-tab-btn[data-tab="hostedvideo"].active');
    if (button) playActiveVideo();
  }

  /**
   * Dải thumbnail dưới khung video, dùng lại class của theme để có sẵn kiểu dáng: ảnh poster
   * kèm biểu tượng play, hai nút tròn điều hướng.
   */
  function buildVideoThumbs(items) {
    var layout = video.panel.querySelector('.cstm-pmg-desktop-layout');
    if (!layout) return;

    // Class riêng, KHÔNG dùng .cstm-video-thumb-slider: handler tab của theme gọi
    // $('.cstm-video-thumb-slider').hide() cho mọi tab khác 'video', mà tab này tên
    // 'hostedvideo' nên dải thumbnail sẽ bị chính theme ẩn đi.
    var slider = layout.querySelector('.cstm-hosted-video-thumbs');
    if (!slider) {
      slider = document.createElement('div');
      slider.className = 'cstm-hosted-video-thumbs';
      slider.innerHTML =
        '<button type="button" class="cstm-video-thumb-prev" aria-label="Video trước">‹</button>' +
        '<div class="cstm-video-thumb-wrapper"></div>' +
        '<button type="button" class="cstm-video-thumb-next" aria-label="Video sau">›</button>';
      layout.appendChild(slider);
    }

    var playIcon = '<div class="cstm-video-icon-overlay">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="#fff"><path d="M8 5v14l11-7z"/></svg>' +
      '</div>';

    slider.querySelector('.cstm-video-thumb-wrapper').innerHTML = items.map(function (item, index) {
      return '<div class="cstm-video-thumb-slide' + (index === 0 ? ' active' : '') + '" data-index="' + index + '">' +
        (item.poster_url ? '<img src="' + item.poster_url + '" alt="Video ' + (index + 1) + '">' : '') +
        playIcon + '</div>';
    }).join('');

    bindVideoSlider(items.length);
  }

  /**
   * Video để muted nên trình duyệt cho phép phát tự động; play() vẫn trả về promise có thể bị
   * từ chối (vd chính sách tiết kiệm pin) nên phải nuốt lỗi, không thì rơi ra unhandled rejection.
   */
  function playActiveVideo() {
    if (!video.panel) return;

    var el = video.panel.querySelector('.cstm-desktop-video-slide.active video');
    if (!el) return;

    var promise = el.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function pauseAllVideos() {
    if (!video.panel) return;

    video.panel.querySelectorAll('video').forEach(function (el) { el.pause(); });
  }

  /** Chuyển video, dừng cái đang phát để không chồng tiếng. */
  function bindVideoSlider(count) {
    if (video.bound) return;
    video.bound = true;

    var current = 0;

    function go(index) {
      var slides = video.panel.querySelectorAll('.cstm-desktop-video-slide');
      var thumbs = video.panel.querySelectorAll('.cstm-video-thumb-slide');
      if (!slides.length) return;

      slides.forEach(function (slide) {
        var el = slide.querySelector('video');
        if (el) el.pause();
        slide.classList.remove('active');
      });
      thumbs.forEach(function (thumb) { thumb.classList.remove('active'); });

      current = ((index % slides.length) + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (thumbs[current]) thumbs[current].classList.add('active');

      // Chọn thumbnail là có ý muốn xem video đó, nên phát luôn thay vì bắt bấm thêm lần nữa
      playActiveVideo();
    }

    video.panel.addEventListener('click', function (event) {
      if (event.target.closest('.cstm-video-thumb-prev')) return go(current - 1);
      if (event.target.closest('.cstm-video-thumb-next')) return go(current + 1);

      var thumb = event.target.closest('.cstm-video-thumb-slide');
      if (thumb) return go(parseInt(thumb.getAttribute('data-index'), 10));

      // Không có controls gốc nên khung video tự đóng vai nút play/pause
      var inner = event.target.closest('.cstm-desktop-video-inner');
      if (inner) toggle(inner);
    });

    /** Overlay chỉ hiện khi video đang dừng — bám theo sự kiện thật của thẻ video. */
    function toggle(inner) {
      var el = inner.querySelector('video');
      if (!el) return;

      if (el.paused) {
        el.play();
      } else {
        el.pause();
      }
    }

    video.panel.addEventListener('play', function (event) {
      var inner = event.target.closest('.cstm-desktop-video-inner');
      if (inner) inner.classList.add('playing');
    }, true);

    video.panel.addEventListener('pause', function (event) {
      var inner = event.target.closest('.cstm-desktop-video-inner');
      if (inner) inner.classList.remove('playing');
    }, true);
  }

  // --- Mobile ------------------------------------------------------------

  /**
   * Liquid chỉ dựng hệ tab mobile khi video_count > 0, mà video_count chỉ đếm video native
   * trên Shopify. Video và spin của ta nằm trên S3 nên sản phẩm rơi vào nhánh else: chỉ có
   * panel #mobile-images-only, không thanh tab nào. Dựng lại bằng JS, song song với desktop.
   *
   * Hai chế độ, để không đẻ ra hai nút "Video" trùng nhau:
   *  - Liquid đã dựng thanh tab (sản phẩm có video native) -> chỉ bổ sung nút 360°.
   *  - Chưa có thanh tab -> dựng đủ Images / 360° / Video (video lấy từ S3).
   */
  var mobile = { items: [], current: 0, bound: false, frames: [] };

  function mobileHost() {
    return document.querySelector('.cstm-mobile-media-container');
  }

  /**
   * Có phải thanh tab do Liquid render sẵn không — chốt một lần lúc khởi tạo.
   * Không hỏi lại DOM về sau: thanh do chính JS này dựng cũng mang class .mobile-tab-nav, nên
   * hỏi lại sẽ nhầm là của Liquid và bỏ qua việc thêm tab Video.
   * Script nạp bằng defer nên DOM đã parse xong ở thời điểm này.
   */
  var liquidMobileVideoPanel = !!document.getElementById('mobile-video');

  function ensureMobilePanel(id) {
    var existing = document.getElementById(id);
    if (existing) return existing;

    var host = mobileHost();
    if (!host) return null;

    var images = document.getElementById('mobile-images');
    var content = (images && images.parentElement) || host;

    var panel = document.createElement('div');
    panel.className = 'mobile-tab-panel';
    panel.id = id;
    content.appendChild(panel);
    return panel;
  }

  /**
   * Thanh tab mobile do Liquid render sẵn (Images + Video), giống hệt oretie. JS chỉ nối thêm
   * đúng một nút 360° khi chất liệu đó có spin — không dựng lại Images/Video để không có cơ hội
   * lệch so với nút gốc.
   */
  function ensureMobileSpinTab() {
    var host = mobileHost();
    if (!host) return null;

    var nav = host.querySelector('.mobile-tab-nav');
    if (!nav) return null;

    var button = nav.querySelector('[data-tab="spin"]');
    if (button) {
      button.hidden = false;
      placeMobileSpinTab(nav, button);
      return nav;
    }

    // Nhân bản đúng nút gốc rồi chỉ thay icon và nhãn, để mọi thuộc tính khác giống hệt.
    var source = nav.querySelector('[data-tab="images"]');
    if (!source) return null;

    button = source.cloneNode(true);
    button.classList.remove('active');
    button.setAttribute('data-tab', 'spin');

    var icon = button.querySelector('svg');
    if (icon) {
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.innerHTML =
        '<ellipse cx="12" cy="12" rx="10" ry="5.2" stroke="currentColor" stroke-width="1.6" fill="none"></ellipse>' +
        '<circle cx="12" cy="12" r="2.6" fill="currentColor"></circle>';
    }

    // Thay phần chữ, giữ nguyên thẻ svg đứng trước
    button.childNodes.forEach(function (node) {
      if (node.nodeType === 3 && node.textContent.trim()) node.textContent = '360°';
    });

    placeMobileSpinTab(nav, button);
    return nav;
  }

  /**
   * Thứ tự tab phải khớp desktop: Images · 360° · Video (xem mảng TABS). Thanh mobile do Liquid
   * render sẵn Images + Video, nên nối nút 360° vào cuối sẽ ra Images · Video · 360°.
   */
  function placeMobileSpinTab(nav, button) {
    var video = nav.querySelector('[data-tab="video"]');
    if (video) nav.insertBefore(button, video);
    else nav.appendChild(button);
  }

  function hideMobileTab(name) {
    var button = document.querySelector('.mobile-tab-nav [data-tab="' + name + '"]');
    if (!button) return;

    button.hidden = true;
    if (!button.classList.contains('active')) return;

    var images = document.querySelector('.mobile-tab-nav [data-tab="images"]');
    if (images) images.click();
  }

  /**
   * Handler tab của theme bind trực tiếp ($('.mobile-tab-btn').on(...)) nên chỉ ăn với nút có
   * sẵn lúc DOM ready — nút do JS tạo sẽ không có gì. Dùng delegated cho chắc.
   */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.mobile-tab-btn');
    if (!button) return;

    var host = mobileHost();
    if (!host || !host.contains(button)) return;

    var tabName = button.getAttribute('data-tab');

    host.querySelectorAll('.mobile-tab-btn').forEach(function (other) {
      other.classList.toggle('active', other.getAttribute('data-tab') === tabName);
    });
    host.querySelectorAll('.mobile-tab-panel').forEach(function (panel) {
      panel.classList.toggle('active', panel.id === 'mobile-' + tabName);
    });

    if (tabName === 'video') {
      playActiveMobileVideo();
    } else {
      host.querySelectorAll('video').forEach(function (el) { el.pause(); });
    }
  });

  function playActiveMobileVideo() {
    var el = document.querySelector('#mobile-video video');
    if (!el) return;

    var promise = el.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  /** Đổi nguồn của khung video mobile sang video thứ `index`, kèm nhãn carat và poster. */
  function showMobileVideo(index) {
    var panel = document.getElementById('mobile-video');
    if (!panel || !mobile.items.length) return;

    var count = mobile.items.length;
    mobile.current = ((index % count) + count) % count;

    var item = mobile.items[mobile.current];
    var el = panel.querySelector('video');
    if (!el) return;

    el.pause();
    el.setAttribute('poster', item.poster_url || '');
    el.setAttribute('src', item.url);
    el.load();

    var label = panel.querySelector('.shown-carat-label');
    if (label) {
      label.textContent = item.carat ? 'Shown with ' + item.carat + ' ct' : '';
      label.hidden = !item.carat;
    }

    panel.querySelectorAll('.mobile-vid-thumb-slide').forEach(function (thumb, i) {
      thumb.classList.toggle('active', i === mobile.current);
    });
  }

  function applyMobileSpin() {
    if (!mobileHost() || !spin.frames.length) return;

    var panel = ensureMobilePanel('mobile-spin');
    if (!panel) return;

    // Dùng lại đúng class khung ảnh mobile của theme (.mobile-featured-wrapper đã khoá tỉ lệ
    // 1:1, .mobile-main-img đã phủ kín khung) để không phải thêm CSS riêng cho 360.
    if (!panel.querySelector('.mobile-main-img')) {
      panel.innerHTML =
        '<div class="mobile-featured-wrapper">' +
        '<div class="mobile-main-media-wrapper">' +
        '<img class="mobile-main-img" alt="360°">' +
        '<div class="cstm-spin-hint">' +
        '<span class="cstm-spin-hint-label">Drag to spin</span>' +
        SPIN_TRACK_SVG +
        '</div>' +
        '</div></div>';
    }

    mobile.frames = spin.frames;
    var img = panel.querySelector('.mobile-main-img');
    img.src = mobile.frames[0];

    ensureMobileSpinTab();

    bindMobileSpinDrag(panel.querySelector('.mobile-main-media-wrapper'), img);
  }

  /** Kéo ngang để xoay, cùng cách tính với bản desktop.
   *  Trên mobile cú kéo luôn có chút thành phần dọc nên trình duyệt cuộn trang theo. Khóa hướng
   *  theo cú di chuyển đầu tiên vượt ngưỡng: ngang -> xoay và chặn cuộn (preventDefault), dọc ->
   *  không đụng vào để trang cuộn bình thường. touch-action: pan-y báo trình duyệt "chiều ngang là
   *  của JS", giúp preventDefault kịp trước khi trình duyệt kịp bắt đầu cuộn. */
  function bindMobileSpinDrag(viewer, img) {
    if (!viewer || viewer._spinBound) return;
    viewer._spinBound = true;

    // Ngón tay chạm lên chính .mobile-main-img nên touch-action phải đặt trên cả img, không chỉ wrapper.
    viewer.style.touchAction = 'pan-y';
    if (img) img.style.touchAction = 'pan-y';

    var dragging = false;
    var startX = 0;
    var startY = 0;
    var startFrame = 0;
    var current = 0;
    var axis = null; // 'x' = xoay, 'y' = cuộn trang, null = chưa khóa hướng

    function pointerX(e) {
      return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
    }
    function pointerY(e) {
      return e.touches && e.touches.length ? e.touches[0].clientY : e.clientY;
    }

    viewer.addEventListener('touchstart', function (e) {
      dragging = true;
      axis = null;
      startX = pointerX(e);
      startY = pointerY(e);
      startFrame = current;
    }, { passive: true });

    viewer.addEventListener('touchmove', function (e) {
      if (!dragging || !mobile.frames.length) return;

      var dx = pointerX(e) - startX;
      var dy = pointerY(e) - startY;

      // Khóa hướng theo cú di chuyển đầu tiên đủ lớn
      if (!axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (axis === 'y') return; // kéo dọc: để trình duyệt cuộn trang

      if (e.cancelable) e.preventDefault(); // kéo ngang: chặn trang cuộn theo

      var count = mobile.frames.length;
      var next = startFrame - Math.round(dx / PIXELS_PER_FRAME);
      current = ((next % count) + count) % count;
      img.src = mobile.frames[current];
    }, { passive: false });

    viewer.addEventListener('touchend', function () { dragging = false; axis = null; });
  }

  function applyMobileVideos(items) {
    if (!mobileHost()) return;

    // Liquid đã dựng sẵn panel video native thì để nguyên, không đè lên
    if (liquidMobileVideoPanel) return;


    if (!items.length) {
      hideMobileTab('video');
      return;
    }

    var panel = ensureMobilePanel('mobile-video');
    if (!panel) return;

    mobile.items = items;

    // Chỉ dựng MỘT khung video rồi đổi nguồn khi bấm thumbnail, thay vì xếp chồng nhiều slide
    // rồi ẩn/hiện — cách đó cần thêm CSS, còn cách này dùng trọn khung video mobile sẵn có.
    panel.innerHTML =
      '<div class="mobile-featured-wrapper"><div class="mobile-video-wrapper-inner">' +
      '<div class="shown-carat-label" hidden></div>' +
      '<video class="mobile-main-video" muted loop playsinline preload="none"></video>' +
      '<div class="mobile-play-overlay"><div class="mobile-play-button">' +
      '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>' +
      '</div></div></div></div>' +
      '<div class="mobile-vid-thumb-slider"><div class="mobile-vid-thumb-wrapper">' +
      items.map(function (item, index) {
        return '<div class="mobile-vid-thumb-slide' + (index === 0 ? ' active' : '') +
          '" data-index="' + index + '">' +
          (item.poster_url ? '<img src="' + item.poster_url + '" alt="Video ' + (index + 1) + '">' : '') +
          '</div>';
      }).join('') +
      '</div></div>';

    showMobileVideo(0);

    bindMobileVideo(panel);
  }

  function bindMobileVideo(panel) {
    if (mobile.bound) return;
    mobile.bound = true;

    panel.addEventListener('click', function (event) {
      var thumb = event.target.closest('.mobile-vid-thumb-slide');
      if (thumb) {
        // Chọn thumbnail là có ý muốn xem video đó nên phát luôn, khỏi bắt bấm thêm lần nữa
        showMobileVideo(parseInt(thumb.getAttribute('data-index'), 10));
        playActiveMobileVideo();
        return;
      }

      var inner = event.target.closest('.mobile-video-wrapper-inner');
      if (!inner) return;

      // Đặt tên khác 'video' để không che biến video cấp module ở trên
      var el = inner.querySelector('video');
      if (!el) return;

      if (el.paused) {
        el.play();
      } else {
        el.pause();
      }
    });

    panel.addEventListener('play', function (event) {
      var inner = event.target.closest('.mobile-video-wrapper-inner');
      if (inner) inner.classList.add('playing', 'mobile-main-video-playing');
    }, true);

    panel.addEventListener('pause', function (event) {
      var inner = event.target.closest('.mobile-video-wrapper-inner');
      if (inner) inner.classList.remove('playing', 'mobile-main-video-playing');
    }, true);
  }

  // --- Nạp dữ liệu -------------------------------------------------------

  function load(material) {
    fetchMedia('spin', material).then(function (data) {
      if (data && data.base_url && data.frame_count) {
        applySpin(data);
        return;
      }

      // Chất liệu này không có spin — ẩn tab thay vì để lại frame của chất liệu trước
      spin.frames = [];
      hideTab('spin');
      hideMobileTab('spin');
    });

    fetchMedia('video', material, currentCarat()).then(applyVideos);
  }

  document.addEventListener('pdp:variant-changed', function () {
    // Đọc lại từ nút đang active thay vì đoán vị trí Material trong variant.options — bộ chọn
    // variant đã cập nhật trạng thái active trước khi phát sự kiện này.
    load(currentMaterial());
  });

  load(currentMaterial());
})();
